import React, { useEffect, useRef } from "react";
import {
  ActionButton,
  Actions,
  CloseButton,
  Content,
  Description,
  Header,
  IconWrapper,
  Overlay,
  Title,
  WrapperModal,
} from "./modal-decoder.molecule.styled";

import WarningIcon from "../../../assets/images/x-modal.png";

type ModalDecoderProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  confirmLabel?: string;
  onConfirm?: () => void;
  iconSrc?: string;
};

export const ModalDecoderMolecule = ({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  onConfirm,
  iconSrc,
}: ModalDecoderProps): JSX.Element | null => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (modalRef.current && e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <Overlay onClick={handleOverlayClick} aria-hidden={!open}>
      <WrapperModal
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Header>
          <div className="top-bar" />
          <CloseButton
            aria-label="Fechar modal"
            onClick={onClose}
            type="button"
          />
        </Header>

        <Content>
          {(iconSrc || WarningIcon) && (
            <IconWrapper>
              <img src={iconSrc ?? WarningIcon} alt="" />
            </IconWrapper>
          )}

          <Title id="modal-title">{title}</Title>

          <Description id="modal-description">{description}</Description>

          <Actions>
            <ActionButton
              type="button"
              onClick={onConfirm ?? onClose}
              data-variant="primary"
            >
              {confirmLabel}
            </ActionButton>
          </Actions>
        </Content>
      </WrapperModal>
    </Overlay>
  );
};
